/**
 * The single definition of the single-family unit-number sentinel (AP-001).
 *
 * Single-family properties store `unitNumber = 'DEFAULT'`. It is truthy and not nullish, so `?`,
 * `??` and `filter(Boolean)` all pass it through. Every place that shows or sends a unit number
 * to a person (UI, email, notification, document, export, prompt) goes through these helpers;
 * nothing outside this file compares against the literal.
 *
 * `packages/mobile-shared/src/unit-number.ts` mirrors this file (mobile-shared cannot take a
 * runtime dependency on `@resida/shared`); `unit-number.contract.test.ts` there enforces parity.
 */
export const DEFAULT_UNIT_NUMBER = 'DEFAULT';
/** The unit number when it is a real one; null for the sentinel, empty, blank or missing. */
export function realUnitNumber(unitNumber) {
    if (unitNumber === null || unitNumber === undefined)
        return null;
    const trimmed = unitNumber.trim();
    return trimmed === '' || trimmed === DEFAULT_UNIT_NUMBER ? null : trimmed;
}
/** "Unit 4B" for a real unit number; null for single-family (callers fall back to the property/address). */
export function formatUnitLabel(unitNumber) {
    const real = realUnitNumber(unitNumber);
    return real ? `Unit ${real}` : null;
}
/** "123 Main St, Unit 4B" for a real unit; just "123 Main St" for single-family. */
export function formatUnitAddress(address1, unitNumber, separator = ', ') {
    const label = formatUnitLabel(unitNumber);
    return label ? `${address1}${separator}${label}` : address1;
}
//# sourceMappingURL=unit-number.js.map